import React from 'react'
import UploadFile from '../comparison/UploadFile'
import AdminBanner from './AdminBanner'
import Breadcrumb from './Breadcrumb'

const AdminPage = () => {
    return (
        <div style={{ backgroundColor: "#F4F7FC" }}>
            <Breadcrumb List={[{ path:"/Dashboard", name:"Dasboard"},{path:"#", name:"Upload Planned Data"}]} />
            <AdminBanner />
            <UploadFile />
        </div>
    )
}

export default AdminPage